import AbstractApiRepository from '~/base/api/AbstractApiRepository';
import { SendSurveyDto } from '~modules/surveys/dto/SendSurveyDto';
import { SurveyCommentsDto } from '~modules/surveys/dto/SurveyCommentsDto';

export default class SurveyApiRepository extends AbstractApiRepository {
  getSurvey = (params: URLSearchParams) => {
    return this.apiClient.get({
      url: '/GetSurvey',
      config: { params },
    });
  };

  sendSurvey = (dto: SendSurveyDto) => {
    return this.apiClient.post({
      url: `/AddSurveyResult`,
      data: dto,
    });
  };

  getSurveyResults = (params: URLSearchParams) => {
    return this.apiClient.get({
      url: '/GetSurveyResults',
      config: { params },
    });
  };

  closeSurvey = (dto: SurveyCommentsDto) => {
    return this.apiClient.put({
      url: '/PostCommentsForSurveyFromDealer',
      data: dto,
    });
  };

  saveCommentsFromDealer = (dto: SurveyCommentsDto) => {
    return this.apiClient.put({
      url: '/UpdateCommentsForSurveyFromDealer',
      data: dto,
    });
  };
}
